import { handleActions } from 'redux-actions';
import {
  mapFreelancerSkillsToDescription,
  mapFreelancerSkillsToDescriptionWithCategory,
  sortById,
} from '../../../shared/helpers';

const TRACKING_ID = 'TRACKING_ID';

export const initialState = {
  user: {},
  token: '',
  errors: false,
  isLogin: false,
  isFetching: false,
  clientActiveTab: true,
  isFetchingAccountUpdate: false,
  loadingMessage: '',
  track: {
    id: localStorage.getItem(TRACKING_ID) || undefined,
  },
};

const authentication = handleActions(
  {
    AUTHENTICATION_SUCCESS: (state, action) => ({
      ...state,
      loginUser: action.payload.data.user,
      token: action.payload.data.token,
      clientActiveTab: action.payload.data.user.type === 'Client',
      isLogin: true,
      isFetching: false,
      errors: false,
    }),

    SET_AUTHENTICATION_TAB: (state, action) => ({
      ...state,
      clientActiveTab: action.payload.data,
    }),

    AUTHENTICATION_REQUEST: state => ({
      ...state,
      isFetching: true,
      user: {},
    }),

    FORGOT_PASSWORD_REQUEST: state => ({
      ...state,
      isFetching: true,
    }),

    FORGOT_PASSWORD_SUCCESS: state => ({
      ...state,
      isFetching: false,
    }),

    FORGOT_PASSWORD_REQUEST_FAILURE: state => ({
      ...state,
      isFetching: false,
    }),

    RESET_PASSWORD_TOKEN_REQUEST: state => ({
      ...state,
      isFetching: true,
    }),

    RESET_PASSWORD_TOKEN_SUCCESS: state => ({
      ...state,
      isFetching: false,
      isReset: true,
    }),

    RESET_PASSWORD_TOKEN_REQUEST_FAILURE: state => ({
      ...state,
      isFetching: false,
    }),

    RESET_PASSWORD_REQUEST: state => ({
      ...state,
      isFetching: true,
    }),

    RESET_PASSWORD_SUCCESS: state => ({
      ...state,
      isFetching: false,
      isReset: false,
    }),

    RESET_PASSWORD_REQUEST_FAILURE: state => ({
      ...state,
      isFetching: false,
    }),

    AUTHENTICATION_REQUEST_FAILURE: state => ({
      ...state,
      isFetching: false,
      user: {},
      token: '',
      isLogin: false,
      errors: true,
    }),

    GET_USER_SUCCESS: (state, action) => ({
      ...state,
      user: {
        ...action.payload.data,
        formatted_skills: mapFreelancerSkillsToDescription(
          action.payload.data.skills,
        ),
        ...mapFreelancerSkillsToDescriptionWithCategory(
          action.payload.data.skills,
        ),
        experiences: sortById(action.payload.data.experiences),
      },
      clientActiveTab: action.payload.data.type === 'Client',
      isFetching: false,
      isLogin: true,
    }),

    GET_USER_REQUEST: state => ({
      ...state,
      isFetching: true,
    }),

    GET_USER_REQUEST_FAILURE: state => ({
      ...state,
      isFetching: false,
    }),

    CREATE_ACCOUNT_SUCCESS: (state, action) => ({
      ...state,
      user: action.payload.data,
      isFetching: false,
    }),

    CREATE_ACCOUNT_REQUEST: state => ({
      ...state,
      isFetching: true,
    }),

    CREATE_ACCOUNT_REQUEST_FAILURE: state => ({
      ...state,
      isFetching: false,
    }),

    UPDATE_ACCOUNT_SUCCESS: (state, action) => ({
      ...state,
      user: {
        ...action.payload.data,
        formatted_skills: mapFreelancerSkillsToDescription(
          action.payload.data.skills,
        ),
        ...mapFreelancerSkillsToDescriptionWithCategory(
          action.payload.data.skills,
        ),
        experiences: sortById(action.payload.data.experiences),
      },
      isFetchingAccountUpdate: false,
      loadingMessage: '',
    }),

    UPDATE_ACCOUNT_REQUEST: state => ({
      ...state,
      isFetchingAccountUpdate: true,
      loadingMessage: 'Saving...',
    }),

    UPDATE_ACCOUNT_REQUEST_FAILURE: state => ({
      ...state,
      isFetchingAccountUpdate: false,
      loadingMessage: '',
    }),

    CONFIRM_EMAIL_REQUEST: state => ({
      ...state,
      isFetching: true,
    }),
    CONFIRM_EMAIL_SUCCESS: state => ({
      ...state,
      isFetching: false,
      emailConfirmed: true,
    }),
    CONFIRM_EMAIL_FAILURE: state => ({
      ...state,
      isFetching: false,
    }),
    AUTHENTICATION_LOGOUT: () => ({
      ...initialState,
    }),
    GET_TRACK_SUCCESS: (state, action) => {
      localStorage.setItem(TRACKING_ID, action.payload.id);
      return {
        ...state,
        track: action.payload,
      };
    },
  },
  initialState,
);

export default authentication;



// WEBPACK FOOTER //
// ./src/store/reducers/Authentication/index.js